import { i18n } from "@/resources/locales";

export const TUTORIAL = [
  {
    text: i18n.t("tutorial.step1"),
  },
  {
    text: i18n.t("tutorial.step2"),
  },
  {
    text: i18n.t("tutorial.step3"),
  },
  {
    text: i18n.t("tutorial.step4"),
  },
  {
    text: i18n.t("tutorial.tutorialComplete"),
  },
];
